import { Components, Theme } from '@mui/material';

const muiIconButton: Components<Theme>['MuiIconButton'] = {
	styleOverrides: {
		root: ({ theme }) => ({
			color: theme.palette.icon,
			'&:hover': {
				backgroundColor: 'rgba(0, 0, 0, 0.03)',
			},
		}),
	},
};

export default muiIconButton;
